import {View} from 'MWC';
import tpl from './templates/interactive.jsx';
import React from 'react';

export default class News extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL
        };

        this.crefs = {};

        return this;
    }

    filterCollection() {
        return this.state.collection;
    }
}
